export default __webpack_public_path__ + "static/hw_ff_potentiometer_led-ecd4ea6814ad02d76cee813045519589.png";